<template>
  <v-app>
    <v-main>
      <template v-if="showHeader">
        <common-header />
      </template>
      <router-view />
    </v-main>

    <t-modal
      :open.sync="globalModal.open"
      :content="globalModal.content"
      width="650px"
      :header="false"
      :icon="globalModal.icon"
      :btnPositive="globalModal.positiveOptions"
      :btnNegative="globalModal.negativeOptions"
      @submit="submitGlobalModal"
      @negative="negativeGlobalModal"
      @close="closeGlobalModal"
    />

    <c-simple-modal
      :open.sync="simpleModal.open"
      :title="simpleModal.title"
      :date="simpleModal.date"
      :width="simpleModal.width"
      :height="simpleModal.height"
      :iconShow="simpleModal.iconShow"
      :lottieShow="simpleModal.lottieShow"
      :btnShow="simpleModal.btnShow"
      :positiveBtnOptions="simpleModal.positiveBtnOptions"
      :negativeBtnOptions="simpleModal.negativeBtnOptions"
      :type="simpleModal.type"
      @submit="submitSimpleModal"
      @cancel="cancelSimpleModal"
    >
      <div
        class="contents"
        :class="{ scroll: simpleModal.content.length > 200 }"
      >
        {{ simpleModal.content }}
      </div>
    </c-simple-modal>

    <TreeDToast :time="toast.time" v-model="toast.show" class="toast-css">
      <img
        :src="toast.iconUrl"
        width="24"
        height="24"
        alt=""
        class="toast-icon"
      />
      <div class="toast-content">
        {{ toast.text }}
      </div>
    </TreeDToast>

    <t-modal
      :open.sync="priceModal.open"
      width="600px"
      :title="priceModal.check ? '' : '단가 동의 계약'"
      :header="priceModal.check ? false : true"
      :useClose="priceModal.check ? true : false"
      :icon="'-'"
      :content="'-'"
      @close="closePriceModal"
    >
      <template v-slot:body>
        <div class="price-body">
          <PriceSign @close="closePriceModal" />
        </div>
      </template>
    </t-modal>

    <bug-report></bug-report>
  </v-app>
</template>

<script>
import CSimpleModal from "@/components/designSystem/CSimpleModal.vue";
import TreeDModal from "@/components/designSystem/CGlobalModal.vue";
import BugReport from "@/components/BugReport.vue";
import CommonHeader from "@/components/Layouts/CommonHeader.vue";
import TreeDToast from "@/components/TreeDToast.vue";
import PriceSign from "@/views/Dashboard/DashboardStatus/components/PriceSign.vue";
import { iAlarm } from "./services";
import util from "./common/util";
import Cookies from "js-cookie";

export default {
  name: "App",
  components: {
    "c-simple-modal": CSimpleModal,
    "t-modal": TreeDModal,
    "bug-report": BugReport,
    "common-header": CommonHeader,
    TreeDToast,
    PriceSign,
  },
  data() {
    return {
      isRouterReady: false,
      prevRoute: {},
      noticeData: { type: "", contents: "", date: "" },
    };
  },
  created() {
    if (this.$store.getters.auth.token) {
      this.$store.commit("auth/setUserDataFromToken");
      this.$store.dispatch("auth/myInfo");
      this.setInitialLocale();
    }
  },
  computed: {
    userData() {
      return this.$store.getters.auth.userData;
    },
    globalModal() {
      return this.$store.getters.common.globalModal;
    },
    simpleModal() {
      return this.$store.state.common.simpleModal;
    },
    notificationModal() {
      return this.$store.state.common.notificationModal;
    },
    showHeader() {
      return this.isRouterReady && this.$route.meta.layout !== "NO_HEADER";
    },
    toast() {
      return this.$store.getters.common.toast;
    },
    priceModal() {
      return this.$store.getters.common.priceModal;
    },
  },
  watch: {
    $route() {
      this.isRouterReady = true;
    },
  },
  mounted() {
    const modalState = this.getCookie("modalVisible");
    this.modalVisible = modalState === "true";
    //this.sendSignal();
    // this.fetchAndShowModal();
  },
  methods: {
    async fetchAndShowModal() {
      const modalClosed = Cookies.get("modalClosed");
      if (modalClosed === "true") {
        return;
      }

      try {
        const result = await iAlarm.getAnnouncement();
        const { code, payload } = result.data;

        // payload나 payload.contents가 없으면 함수 종료
        if (code !== "" || !payload || !payload.contents) {
          return;
        }

        // finishedAt과 startedAt의 존재 여부에 따라 type 결정
        const hasDates =
          payload.contents.finishedAt && payload.contents.startedAt;
        const modalType = hasDates ? "notification" : "update";
        let contents;
        if (modalType === "notification") {
          contents =
            "문제 해결, 새로운 기능 추가를 위한 서버 점검이 진행될 예정입니다. \n사이트에 접속이 되더라도 작업 내역이 저장되지 않을 수 있으니 \n점검 시간에는 작업을 중단해 주세요.";
        } else {
          // message 속성이 없을 경우 기본값 설정
          contents = payload.contents.message || "업데이트 공지";
        }
        // 쿠키에 저장된 모달 타입과 다른 경우에만 모달 표시
        const storedModalType = Cookies.get("modalType");
        if (storedModalType !== modalType) {
          this.noticeData = {
            type: modalType,
            contents: contents,
            date: hasDates
              ? util.formatDate(
                  payload.contents.startedAt,
                  payload.contents.finishedAt
                )
              : "",
          };

          this.$store.commit("common/openSimpleModal", {
            content: this.noticeData.contents,
            date: this.noticeData.date,
            title:
              modalType === "notification" ? "서버 점검 공지" : "업데이트 공지",
            iconShow: false,
            btnShow: false,
            type: this.noticeData.type,
            positiveBtnOptions: { show: false, text: "확인" },
            negativeBtnOptions: { show: false },
          });

          // 모달 타입과 닫힘 상태 쿠키에 저장
          Cookies.set("modalType", modalType, { expires: 7 });
          Cookies.set("modalClosed", "false", { expires: 7 });
        }
      } catch (error) {
        console.error("Error fetching announcement:", error);
      }
    },
    cancelSimpleModal() {
      // 모달이 닫힘 상태로 설정
      Cookies.set("modalClosed", "false", { expires: 7 });
      if (this.simpleModal.cancelFn) {
        this.simpleModal.cancelFn();
      }
      this.$store.commit("common/closeSimpleModal");
    },
    async sendSignal() {
      try {
        const result = await iAlarm.getAnnouncement();
        const { code, payload } = result.data;

        if (code !== "" || !payload || !payload.contents) {
          return;
        }

        this.modalVisible = true; // Show modal when data is received
        //쿠키설정
        this.setCookie("modalVisible", true, 7);
        this.noticeData = { ...this.noticeData, contents: payload.contents };

        if (payload.contents.finishedAt && payload.contents.startedAt) {
          const { finishedAt, startedAt } = payload.contents;
          this.noticeData.type = "notification";
          this.noticeData.date = util.formatDate(startedAt, finishedAt);
          this.noticeData.contents =
            "문제 해결, 새로운 기능 추가를 위한 서버 점검이 진행될 예정입니다. \n사이트에 접속이 되더라도 작업 내역이 저장되지 않을 수 있으니 \n점검 시간에는 작업을 중단해 주세요.";
        } else {
          this.noticeData.type = "update";
          this.noticeData.contents =
            payload.contents.message || "업데이트 공지";
        }

        if (this.modalVisible) {
          this.$store.commit("common/openSimpleModal", {
            content: this.noticeData.contents,
            date: this.noticeData.date,
            title:
              this.noticeData.type === "notification"
                ? "서버 점검 공지"
                : "업데이트",
            icon: "warn",
            iconShow: false,
            btnShow: false,
            type: this.noticeData.type,
            negativeBtnOptions: { show: false },
            positiveBtnOptions: { show: false },
          });
        }
      } catch (error) {
        console.error("Error sending fake signal:", error);
      }
    },
    setInitialLocale() {
      if (!this.userData) {
        return;
      }
      this.$i18n.locale = this.userData.language;
    },
    async submitGlobalModal() {
      this.$store.commit("common/closeGlobalModal");

      if (this.globalModal.positiveFn) {
        if (this.globalModal.positiveParams) {
          await this.globalModal.positiveFn(this.globalModal.positiveParams);
        }
        await this.globalModal.positiveFn();
      }
    },
    async negativeGlobalModal() {
      if (!this.globalModal.negativeFn) {
        return;
      }

      if (this.globalModal.negativeParams) {
        await this.globalModal.negativeFn(this.globalModal.negativeParams);
      }
      await this.globalModal.negativeFn();
    },
    async closeGlobalModal() {
      if (this.globalModal.closeFn) {
        await this.globalModal.closeFn();
      }
    },

    async submitSimpleModal() {
      if (this.simpleModal.submitFn) {
        await this.simpleModal.submitFn();
      }
      this.$store.commit("common/closeSimpleModal");
    },
    setCookie(name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie =
        name + "=" + value + ";expires=" + expires.toUTCString();
    },

    getCookie(name) {
      const keyValue = document.cookie.match(
        "(^|;) ?" + name + "=([^;]*)(;|$)"
      );
      return keyValue ? keyValue[2] : null;
    },
    async closePriceModal(data) {
      this.$store.commit("common/closePriceModal");
      this.$store.commit("wsd/SET_PRICE_MODAL", { priceModal: false });

      if (data !== undefined) {
        this.$store.commit("common/setPriceModal", data);
      }

      if (this.priceModal.closeFn) {
        await this.priceModal.closeFn();
      }

      this.$store.commit("common/clearPriceModal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./assets/css/main.css";

#app {
  background-color: var(--c-white);
}

.v-main {
  width: 100svw;
  margin: 0 auto;
  transition: none;
  overflow-x: hidden;
}

.v-main.full {
  width: 100%;
}

.toast-css {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: auto !important;
  height: 64px !important;
}

.toast-css .toast-icon {
  margin: 23px 10px 0px 12px;
}

.toast-css .toast-content {
  margin-top: 24px;
  color: var(--mono-m-black01, #333);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.94px;
  margin-right: 15px;
}
.contents {
  color: var(--mono-m-gray00, #666);
  text-align: center;

  /* Title3 500 */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.94px; /* 133% */
  &.scroll {
    display: flex;
    overflow: auto;
    height: 110px;
    padding: 10.5px 12px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    color: var(--mono-m-gray00, #666);
    text-align: center;
    border-radius: 10px;
    background: var(--mono-m-gray-04-mouse-over, #f5f5f5);
    /* Body 400 */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18.6px; /* 132.857% */
  }
}

.price-body {
  width: 100%;
  height: 100%;
  padding: 0px 25px;
  margin-bottom: -30px;
}
</style>
